import { render, staticRenderFns } from "./TagManager.vue?vue&type=template&id=ab36eae2&"
import script from "./TagManager.vue?vue&type=script&lang=js&"
export * from "./TagManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports